import { api } from '@setplex/tria-api'
import { createEvent, createStore, sample } from 'effector'
import { model as subscriberModel } from '~/entities/subscriber'
import { T } from '~/shared/helpers'

/**
 * Toggle the pin lock profiles feature
 */
export const toggle = createEvent<boolean>()

sample({
  clock: toggle,
  target: api.subscriber.updateProfileSwitchLockedFx,
})

/**
 * Store that indicates whether the pin lock profiles feature is enabled or disabled.
 * Follows the clicked value immediately, then the loaded subscriber, and reverts on persist fail.
 */
export const $enabled = createStore(false)
  .on(toggle, (_, value) => value)
  .on(subscriberModel.$subscriber, (state, subscriber) =>
    subscriber == null ? state : (subscriber.profileSwitchLocked ?? false)
  )
  .on(
    api.subscriber.updateProfileSwitchLockedFx.fail,
    (_, { params }) => !params
  )

export const setUnlocked = createEvent<number | null>()
export const resetUnlocked = createEvent()
export const $unlocked = createStore<boolean>(false)
  .on(setUnlocked, T)
  .reset(resetUnlocked)
